import React from 'react';
import { Stack } from '@fiverr-private/layout_components';
import { ButtonExpansionLess, ButtonExpansionMore } from '../../ButtonExpansion';

type ExpansionControlProps = Readonly<{
    totalCount: number;
    expanded: boolean;
    onExpand: () => void;
    onCollapse: () => void;
}>;

export const ExpansionControl = ({ totalCount, expanded, onExpand, onCollapse }: ExpansionControlProps) => (
    <Stack>
        {expanded && <ButtonExpansionLess onClick={onCollapse} />}
        {!expanded && <ButtonExpansionMore onClick={onExpand} totalCount={totalCount} />}
    </Stack>
);
